import { createStyles, makeStyles } from '@material-ui/core/styles';

const styles = () => {
    return createStyles({
        shapeCircular: {
            borderRadius: '32px',
        },
        shapeRounded: {
            borderRadius: '9px',
        },
    });
};

export default makeStyles(styles, { name: 'MuiChipExtend' });
